/** Whether a rate (or template) applies on the calendar day `ymd` (`YYYY-MM-DD`). */
export function isRateEffectiveOn(row, ymd) {
    const from = row.effective_from ?? null;
    const to = row.effective_to ?? null;
    return (from === null || from <= ymd) && (to === null || to >= ymd);
}
/**
 * The default rate in force on `ymd`: the first row that is `is_default` AND
 * whose window covers the day. A rate change hands the default to its
 * successor by closing the old row's window (`effective_to`) and opening the
 * new one, so one direction can hold two `is_default` rows with
 * non-overlapping windows (20261029100000) — `find(r => r.is_default)` alone
 * would pick whichever comes first, possibly the expired one.
 */
export function findEffectiveDefault(rows, ymd) {
    return (rows ?? []).find((row) => row.is_default === true && isRateEffectiveOn(row, ymd));
}
//# sourceMappingURL=taxRateWindow.js.map